<div class="login-page">
  <mat-card class="login-card">
    <mat-card-content>
      <h2 class="login-title">Logowanie</h2>

      <form (ngSubmit)="login()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Login</mat-label>
          <input matInput type="text" name="login" autocomplete="username" [(ngModel)]="userLogin.login">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Hasło</mat-label>
          <input matInput type="password" name="haslo" autocomplete="current-password" [(ngModel)]="userLogin.haslo">
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" class="full-width login-btn">
          Zaloguj
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
